import * as Utils from "../utils/Config";
import { AuthContextModel } from "../App";
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IInvoiceData, ICreateInvoice, IInvoice, IInvoiceRow, SelectionAreaInvoiceDataRow, InvoiceDataInformation } from "../models/IInvoice";
import { ITreatmentType } from "../models/ITreatmentType";
import { formatDate } from "../helpers/DateHelper";
import { IPage } from "../models/IPage";
import { objectToQueryString } from "../helpers/ApiHelper";
import { IPatientTreatment } from "../models/IPatientTreatment";

export class InvoiceApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getTreatmentTypes(success: (data: ITreatmentType[]) => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/invoice/treatmentTypes`, success);
    }

    getTreatmentTypesForCreateInvoice(success: (data: ITreatmentType[]) => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/invoice/treatmentTypesForCreateInvoice`, success);
    }

    getInvoiceData(data: ICreateInvoice, success: (data: InvoiceDataInformation) => void, error: (message: string) => void, final: () => void) {
        var query = objectToQueryString(data);
        this.get(`${Utils.LIB_API_BASE_URL}/invoice/invoiceData?${query}`, success, error, final);
    }

    getInvoiceDataRows(treatmentTypeId: number, careProviderId: number, success: (data: IPatientTreatment[] | SelectionAreaInvoiceDataRow[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/invoice/invoiceDataRows/${treatmentTypeId}/${careProviderId}`, success, error, final);
    }

    createInvoices(data: ICreateInvoice, success: () => void, error: (message: string) => void, final: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/invoice`, data, success, error, final);
    }

    getInvoice(invoiceId: number, success: (data: IInvoice) => void, final: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/invoice/${invoiceId}`, success, undefined, final);
    }

    getInvoiceRows(invoiceId: number, pageSelect: IPage, success: (data: IPaginatedResponse<IInvoiceRow[]>) => void, final: () => void) {
        const queryString = objectToQueryString(pageSelect);
        this.getPaginated<IInvoiceRow[]>(`${Utils.LIB_API_BASE_URL}/invoice/${invoiceId}/invoiceRows?${queryString}`, success, undefined, final);
    }

    getInvoiceExcel(invoiceId: number, error?: (message: string) => void, final?: () => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/invoice/exportToExcel/${invoiceId}`, `Faktura ${formatDate()}`, undefined, error, final);
    }
}